// Auto generated file, do not manually modify!
// com.hotpads.capps.handler.web.renter.v1.CappsRentPaymentWebApiHandler

import type { QueryOptions, UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  CappsRentPaymentWebApiHandler_getRenterRequestPaymentApplication,
  CappsRentPaymentWebApiHandler_getRenterRequestPaymentApplication_Path,
  CappsRentPaymentWebApiHandler_optInRenterRequestPaymentApplication,
  CappsRentPaymentWebApiHandler_optOutRenterRequestPaymentApplication,
} from '@zg-rentals/ts-capps-client';

import type {
  CappsGetRenterRequestPaymentApplicationApiRequestDto,
  CappsGetRenterRequestPaymentApplicationApiResponseDto,
  CappsOptInRenterRequestPaymentApplicationApiRequestDto,
  CappsOptInRenterRequestPaymentApplicationApiResponseDto,
  CappsOptOutRenterRequestPaymentApplicationApiRequestDto,
  CappsOptOutRenterRequestPaymentApplicationApiResponseDto,
} from '@zg-rentals/ts-capps-client';

export type CappsRentPaymentWebApiHandler_getRenterRequestPaymentApplication_Options = UseQueryOptions<
  CappsGetRenterRequestPaymentApplicationApiResponseDto,
  unknown,
  CappsGetRenterRequestPaymentApplicationApiResponseDto,
  readonly [string, CappsGetRenterRequestPaymentApplicationApiRequestDto]
>;

const CappsRentPaymentWebApiHandler_getRenterRequestPaymentApplication_GetKey = (
  postData: CappsGetRenterRequestPaymentApplicationApiRequestDto,
) => [CappsRentPaymentWebApiHandler_getRenterRequestPaymentApplication_Path, postData] as const;

export const CappsRentPaymentWebApiHandler_getRenterRequestPaymentApplication_queryOptions = (
  postData: CappsGetRenterRequestPaymentApplicationApiRequestDto,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: CappsRentPaymentWebApiHandler_getRenterRequestPaymentApplication_GetKey(postData),
    queryFn: () => CappsRentPaymentWebApiHandler_getRenterRequestPaymentApplication(postData, httpClient),
  }) as const satisfies QueryOptions;

export const useCappsRentPaymentWebApiHandler_getRenterRequestPaymentApplication = (
  postData: CappsGetRenterRequestPaymentApplicationApiRequestDto,
  {
    httpClient,
    ...options
  }: Omit<CappsRentPaymentWebApiHandler_getRenterRequestPaymentApplication_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...CappsRentPaymentWebApiHandler_getRenterRequestPaymentApplication_queryOptions(postData, { httpClient }),
    ...options,
  });
};
useCappsRentPaymentWebApiHandler_getRenterRequestPaymentApplication.getKey =
  CappsRentPaymentWebApiHandler_getRenterRequestPaymentApplication_GetKey;

export interface CappsRentPaymentWebApiHandler_optInRenterRequestPaymentApplication_Args {
  postData: CappsOptInRenterRequestPaymentApplicationApiRequestDto;
}

export type CappsRentPaymentWebApiHandler_optInRenterRequestPaymentApplication_Options = UseMutationOptions<
  CappsOptInRenterRequestPaymentApplicationApiResponseDto,
  unknown,
  CappsRentPaymentWebApiHandler_optInRenterRequestPaymentApplication_Args
>;

export const useCappsRentPaymentWebApiHandler_optInRenterRequestPaymentApplication = ({
  httpClient,
  ...options
}: Omit<CappsRentPaymentWebApiHandler_optInRenterRequestPaymentApplication_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: CappsRentPaymentWebApiHandler_optInRenterRequestPaymentApplication_Args) =>
      CappsRentPaymentWebApiHandler_optInRenterRequestPaymentApplication(args.postData, httpClient),
  });
};

export interface CappsRentPaymentWebApiHandler_optOutRenterRequestPaymentApplication_Args {
  postData: CappsOptOutRenterRequestPaymentApplicationApiRequestDto;
}

export type CappsRentPaymentWebApiHandler_optOutRenterRequestPaymentApplication_Options = UseMutationOptions<
  CappsOptOutRenterRequestPaymentApplicationApiResponseDto,
  unknown,
  CappsRentPaymentWebApiHandler_optOutRenterRequestPaymentApplication_Args
>;

export const useCappsRentPaymentWebApiHandler_optOutRenterRequestPaymentApplication = ({
  httpClient,
  ...options
}: Omit<CappsRentPaymentWebApiHandler_optOutRenterRequestPaymentApplication_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: CappsRentPaymentWebApiHandler_optOutRenterRequestPaymentApplication_Args) =>
      CappsRentPaymentWebApiHandler_optOutRenterRequestPaymentApplication(args.postData, httpClient),
  });
};
